<!-- Game -->
<div class="game">
    <app-board></app-board>
</div>
